import type { IntlShape } from 'react-intl';

export interface ComposeJobRunDescriptionInput {
  batchTypeLabel: string | null;
  modelLabel: string | null;
  promptLabel: string | null;
  /** ai-prompts branch name — only set when it isn't the default `main`. */
  branchLabel?: string | null;
}

/**
 * `"Validation run using Claude Sonnet 5 with the stroke experimental prompt"`,
 * or `"...prompt (branch: X)"` when a non-default branch was picked.
 * Takes resolved display labels and a `formatMessage` function rather than an
 * `intl` object so it stays a pure, unit-testable function — the caller resolves
 * batch/model/prompt/branch labels first.
 */
export const composeJobRunDescription = (
  { batchTypeLabel, modelLabel, promptLabel, branchLabel }: ComposeJobRunDescriptionInput,
  formatMessage: IntlShape['formatMessage']
): string => {
  if (!batchTypeLabel || !modelLabel || !promptLabel) {
    return '';
  }

  if (branchLabel) {
    return formatMessage(
      { id: 'adminProjects.generateAccuracy.description.composedTemplateWithBranch' },
      { batchTypeLabel, modelLabel, promptLabel, branchLabel }
    );
  }

  return formatMessage(
    { id: 'adminProjects.generateAccuracy.description.composedTemplate' },
    { batchTypeLabel, modelLabel, promptLabel }
  );
};
